import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { AudienceFilterItemInput } from '../../../../../../common/components/AudienceFilterItemInput/AudienceFilterItemInput';
import {
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '../../../../../../common/modals/modal-helpers';
import { FILTER_TYPES, FilterItem } from '@mm/state/model/AudiencesModel';
import { StoreState } from '@mm/state/store-interfaces';
import {
  AddFilterType,
  LocalVariablesValueFilterItem,
  UpdateFilterType,
} from '../../../sharedFilterTypes';
import './variableValuesModal.scss';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import classNames from 'classnames';

type OuterProps = {
  toggle: () => void;
  onFinish: AddFilterType;
  onUpdateFilter: UpdateFilterType;
  selectedFilter?: LocalVariablesValueFilterItem;
  selectedFilterId?: number | null;
  nonModalUse?: boolean;
  className?: string;
};

type InnerProps = ReturnType<typeof mapStateToProps>;

type Props = OuterProps & InnerProps;

const mapStateToProps = (state: StoreState) => ({
  variables: state.audiences.variables,
});

const enhance = compose<InnerProps, OuterProps>(connect(mapStateToProps));

const VariableValuesModal = (props: Props) => {
  const {
    selectedFilterId,
    selectedFilter,
    onUpdateFilter,
    onFinish,
    toggle,
    variables,
    nonModalUse,
    className,
  } = props;

  const [filter, setFilter] = useState<FilterItem | undefined>();
  const onClose = () => {
    setFilter(undefined);
    toggle();
  };

  useEffect(() => {
    if (selectedFilterId && selectedFilter) {
      setFilter({ ...selectedFilter });
    } else {
      setFilter({
        filterType: '',
        operator: undefined,
        value: '',
        variable: variables[0].name,
        variableId: variables[0] ? variables[0].variableId : 0,
        variableType: variables[0]
          ? variables[0].variableType
          : 'SystemVariable',
      });
    }
  }, [selectedFilter, selectedFilterId]);

  const onSave = () => {
    if (!filter) return;
    onFinish({ ...filter, filterType: FILTER_TYPES.variableValues });
    onClose();
  };

  const onUpdate = () => {
    if (!selectedFilterId || !filter) return;
    onUpdateFilter(selectedFilterId, {
      ...filter,
      filterType: FILTER_TYPES.variableValues,
    });
    onClose();
  };

  const header = (
    <span className="variable-values-modal__header-content">
      {selectedFilterId ? 'Update' : 'Create'} Filter Based on attribute
    </span>
  );

  const body = filter && (
    <AudienceFilterItemInput filter={filter} setFilter={setFilter} withEmoji />
  );

  const footer = (
    <div className="variable-values-modal__buttons">
      <PrimaryButton color={ButtonColor.secondaryBlue} onClick={onClose}>
        Cancel
      </PrimaryButton>
      {selectedFilterId ? (
        <PrimaryButton disabled={!filter || !filter.valid} onClick={onUpdate}>
          Update
        </PrimaryButton>
      ) : (
        <PrimaryButton disabled={!filter || !filter.valid} onClick={onSave}>
          Save
        </PrimaryButton>
      )}
    </div>
  );

  let content = (
    <>
      <ModalHeader className="variable-values-modal__header" toggle={onClose}>
        {header}
      </ModalHeader>
      <ModalBody className="variable-values-modal__container">{body}</ModalBody>
      <ModalFooter className="variable-values-modal__footer">
        {footer}
      </ModalFooter>
    </>
  );

  if (nonModalUse) {
    content = (
      <>
        {body}
        {footer}
      </>
    );
  }

  return (
    <div className={classNames(className, 'variable-values-modal')}>
      {content}
    </div>
  );
};

export default enhance(VariableValuesModal);
